import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import type { MultiplePartnerValue } from "../../types";
import { MultiplePartnerInputBase } from "../../shared/MultiplePartnerInputBase";

export const MultiplePartnerInput: FC<InputProps<MultiplePartnerValue> & { header: string }> = props => {
  return <MultiplePartnerInputBase {...props} isMultistepFormVersion={false} />;
};
